export class PaymentSession {
  paymentOrchestratorId?: string;
  paymentStatus?: string;
  checkoutSessionStatus: string;
  paymentIntentId?: string;
  checkoutSessionExpirationUtc: string;
  programCode?: string;
  productCategory?: string;
  originatingSystem?: string;
  currency?: string;
  cost?: number;
  clientCode?: string;
  examCode?: string;
  siteCode?: string;
  successUrl?: string;
  timeoutInMinutes?: number;
  totalItems?: number;
  accountId?: string;


  constructor(paymentOrchestratorId: string, paymentStatus: string, checkoutSessionStatus: string, paymentIntentId: string, checkoutSessionExpirationUtc: string, programCode: string, productCategory: string, originatingSystem: string, currency: string, cost: number, clientCode: string, examCode: string, siteCode: string, successUrl: string, timeoutInMinutes: number, totalItems: number) {
    this.paymentOrchestratorId = paymentOrchestratorId;
    this.paymentStatus = paymentStatus;
    this.checkoutSessionStatus = checkoutSessionStatus;
    this.paymentIntentId = paymentIntentId;
    this.checkoutSessionExpirationUtc = checkoutSessionExpirationUtc;
    this.programCode = programCode;
    this.productCategory = productCategory;
    this.originatingSystem = originatingSystem;
    this.currency = currency;
    this.cost = cost;
    this.clientCode = clientCode;
    this.examCode = examCode;
    this.siteCode = siteCode;
    this.successUrl = successUrl;
    this.timeoutInMinutes = timeoutInMinutes;
    this.totalItems = totalItems;
  }
}

export class CreatePaymentSessionRequest {
  cost?: number;
  currency?: string;
  clientCode?: string;
  programCode?: string;
  examCode?: string;
  cardFee?: string;
  isProctor?: boolean;
  termUrl?: string;

  constructor(cost: number, currency: string, clientCode: string, programCode: string, examCode: string, cardFee: string, isProctor: boolean, termUrl: string) {
    this.cost = cost;
    this.currency = currency;
    this.clientCode = clientCode;
    this.programCode = programCode;
    this.examCode = examCode;
    this.cardFee = cardFee;
    this.isProctor = isProctor;
    this.termUrl = termUrl;
  }
}

export class PaymentOrchestratorRequest {
  paymentOrchestratorId?: string;
  orderNumber?: string;
  divisionNumber?: string;
  type?: string;
  sessions?: any[];
  currency?: string;
  amount?: number;

  constructor(paymentOrchestratorId: string, orderNumber: string, divisionNumber: string, type: string, sessions: any[], currency: string, amount: number) {
    this.paymentOrchestratorId = paymentOrchestratorId;
    this.orderNumber = orderNumber;
    this.divisionNumber = divisionNumber;
    this.type = type;
    this.sessions = sessions;
    this.currency = currency;
    this.amount = amount;
  }
}

export class CreatePaymentSessionResponse {
  paymentOrchestratorId: string;
  paymentOrchestratorUrl: string;
  checkoutSessionExpirationUtc: string;
  paymentIntentId: string;
  accountId: string;

  constructor(paymentOrchestratorId: string, paymentOrchestratorUrl: string, checkoutSessionExpirationUtc: string, paymentIntentId: string, accountId: string) {
    this.paymentOrchestratorId = paymentOrchestratorId;
    this.paymentOrchestratorUrl = paymentOrchestratorUrl;
    this.checkoutSessionExpirationUtc = checkoutSessionExpirationUtc;
    this.paymentIntentId = paymentIntentId;
    this.accountId = accountId;
  }
}